import React from "react";
import SEO from "./SEO";

function trackEvent(action, label) {
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: "CTA",
      event_label: label,
    });
  }
}

function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <SEO
        title="Cloud Consulting & DevOps Services | Sukun"
        description="Expert Cloud & DevOps services for startups and enterprises. Kubernetes, GCP, AWS, GitOps, and scalable infrastructure solutions."
        keywords={["Cloud Consulting", "DevOps", "Kubernetes", "AWS", "GCP", "GitOps", "Infrastructure"]}
      />
      <h2 id="hero-title">Cloud. Kubernetes. Scaling. Reliability.</h2>
      <p>Helping startups and businesses build fast, scalable, and reliable infrastructure.</p>
      <a
        href="/contact"
        className="cta-button"
        onClick={() => trackEvent("cta_click", "Book a Free Consultation")}
      >
        Book a Free Consultation
      </a>
    </section>
  );
}

export default Hero;